<template>
    <div class="hold-transition login-page ">
      <slot />
    </div>
  </template>